import { render, staticRenderFns } from "./Triangle4Footer.vue?vue&type=template&id=93d5e374&"
import script from "./Triangle4Footer.vue?vue&type=script&lang=js&"
export * from "./Triangle4Footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports